export function getSegmentOptions() {
  return ['Aframax', 'Panamax', 'Suezmax', 'Intermediate', 'Handy (1-6W)', 'Handy (1-9W)', 'VLCC'];
}
export function getGradeOptions() {
  return ['D.P.P', 'I.M.O.3'];
}
export function getShipNameOptions() {
  return ['Ship-A', 'Ship-B'];
}
export function getCargoOptions() {
  return ['Cargo-1', 'Palm Olein'];
}
export function getTanksOptions() {
  return ['1-PORT', '2-PORT', '3-PORT', '1-STBD'];
}
export function getRecordsOptions() {
  return ['Past Records', 'Forecast Records'];
}
export function getvesselname() {
  return ['Vess-A', 'Vess-B'];
}
export function gettypeofreport() {
  return ['Tank Temp Forecast', 'Bunker Consumption Estimate','Heat Plan','final_report'];
}
export function getmonths() {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
}
  export function normalizeSegment(segment: string): string {
    const validSegments = ['LR1', 'LR2', 'LR3', 'VLCC', 'MR2'];
    if (!segment) return segment;

    let seg = segment.toString().trim();

    if (seg.toUpperCase() === 'MR') {
      return 'MR2';
    } else if (validSegments.includes(seg.toUpperCase())) {
      return seg.toUpperCase();
    } else {
      return seg.charAt(0).toUpperCase() + seg.slice(1).toLowerCase();
    }
  }